module.exports = __webpack_public_path__ + "img/EOTP_UI_obstacles.24cd3ecd.svg";